var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.333C14.8325 20.333 18.75 16.4155 18.75 11.583C18.75 6.75052 14.8325 2.83301 10 2.83301C5.16751 2.83301 1.25 6.75052 1.25 11.583C1.25 13.1523 1.66312 14.6251 2.38655 15.8986L1.25 20.333L5.82179 19.2729C7.06336 19.9489 8.48682 20.333 10 20.333ZM10 18.9869C14.089 18.9869 17.4038 15.672 17.4038 11.583C17.4038 7.49398 14.089 4.17916 10 4.17916C5.91097 4.17916 2.59615 7.49398 2.59615 11.583C2.59615 13.1618 3.09031 14.6252 3.9324 15.8269L3.26923 18.3138L5.79996 17.6811C6.99335 18.5046 8.44036 18.9869 10 18.9869Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.958C17.5 15.1001 14.1421 18.458 10 18.458C8.4201 18.458 6.9543 17.9695 5.74541 17.1353L3.18182 17.7762L3.8536 15.257C3.00058 14.0397 2.5 12.5573 2.5 10.958C2.5 6.81587 5.85786 3.45801 10 3.45801C14.1421 3.45801 17.5 6.81587 17.5 10.958Z",
    fill: "url(#paint0_linear_3976_422339)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.708C14.8325 19.708 18.75 15.7905 18.75 10.958C18.75 6.12552 14.8325 2.20801 10 2.20801C5.16751 2.20801 1.25 6.12552 1.25 10.958C1.25 12.5273 1.66312 14.0001 2.38655 15.2736L1.25 19.708L5.82179 18.6479C7.06336 19.3239 8.48682 19.708 10 19.708ZM10 18.3619C14.089 18.3619 17.4038 15.047 17.4038 10.958C17.4038 6.86898 14.089 3.55416 10 3.55416C5.91097 3.55416 2.59615 6.86898 2.59615 10.958C2.59615 12.5368 3.09031 14.0002 3.9324 15.2019L3.26923 17.6888L5.79996 17.0561C6.99335 17.8796 8.44036 18.3619 10 18.3619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81251 6.89538C7.60447 6.47752 7.28533 6.51451 6.96292 6.51451C6.38673 6.51451 5.48828 7.20468 5.48828 8.48917C5.48828 9.54187 5.95216 10.6942 7.51526 12.418C9.02378 14.0816 11.0059 14.9422 12.6514 14.9129C14.2969 14.8836 14.6354 13.4676 14.6354 12.9894C14.6354 12.7774 14.5039 12.6717 14.4133 12.643C13.8525 12.3738 12.8183 11.8724 12.583 11.7782C12.3477 11.684 12.2248 11.8114 12.1484 11.8807C11.935 12.0841 11.512 12.6834 11.3672 12.8182C11.2224 12.953 11.0064 12.8848 10.9166 12.8339C10.5859 12.7012 9.68933 12.3024 8.97467 11.6096C8.09083 10.7528 8.03896 10.458 7.87244 10.1956C7.73922 9.98573 7.83698 9.85693 7.88576 9.80065C8.07619 9.58092 8.33913 9.24169 8.45705 9.07311C8.57496 8.90453 8.48135 8.64858 8.42518 8.48917C8.18361 7.80358 7.97895 7.22966 7.81251 6.89538Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3976_422339",
    x1: 16.5625,
    y1: 5.33301,
    x2: 2.5,
    y2: 18.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7ea67ef3443eb0c3453ed61f9699c6ce.svg";
export { ForwardRef as ReactComponent };